import React from "react";

import { faCalendarCheck } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import type { EventExtraData } from "~/calendar/ViewEvent/index";

import styles from "./ViewEvent.module.css";

export default function CalendarRow({ calendar }: { calendar: EventExtraData["calendar"] }) {
	const colorStyles = calendar.color ? { backgroundColor: calendar.color } : {};

	return (
		<div className={styles.infoRow}>
			<div className={cx(styles.infoRow__icon, styles.centered)}>
				<FontAwesomeIcon fixedWidth icon={faCalendarCheck} />
			</div>
			<div className={styles.infoRow__text}>
				<div className={styles.calendarRow}>
					<div className={styles.calendarColorDot} style={colorStyles} />
					<div>{calendar.sourcePrimary ? "Primary calendar" : calendar.name}</div>
				</div>
			</div>
		</div>
	);
}
